import React from "react";
import { Clock3 } from "lucide-react";

const ComingSoon = () => {
  return (
    <main className="service-screen flex min-h-64 flex-col items-center justify-center text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#eef5fd] text-[#0351b3]">
        <Clock3 size={28} aria-hidden="true" />
      </span>
      <div>
        <h1 className="mb-2 text-xl font-bold text-slate-900">
          Coming Soon
        </h1>
        <p className="text-sm text-slate-500">
          Journey to a bright future!!
        </p>
      </div>
    </main>
  );
};

export default ComingSoon;
